import type { CSSProperties } from 'react';

export const sentryDNS = import.meta.env.VITE_SENTRY_DNS;
export const reCAPTCHA = import.meta.env.VITE_RECAPTCHA_ENTERPRICE_KEY;

export const RecaptchaBranding = ({ style }: { style?: CSSProperties }) => (
  <span style={style}>
    This site is protected by reCAPTCHA and the Google
    <a href="https://policies.google.com/privacy">Privacy Policy</a> and
    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
  </span>
);
